import { AnalyticsBrowser } from "@segment/analytics-next";

// -----------------------------------------------------------------------------

const SegmentKey = "1gBN8BnIr5pYzl2vQV0ybnOKUGL9kKzA";

// -----------------------------------------------------------------------------

const segmentIsEnabled =
  !process.env.REACT_APP_NO_CLEARBIT && !process.env.REACT_APP_NO_EXTERNAL;

const analytics = segmentIsEnabled
  ? AnalyticsBrowser.load({
      writeKey: SegmentKey,
    })
  : {
      page: (pageName: string, data: unknown) =>
        console.info("Analytics.page", pageName, data),
      track: (activity: string, data: unknown) =>
        console.info("Analytics.track", activity, data),
    };

//
!segmentIsEnabled && console.log("Segment disabled");

// -----------------------------------------------------------------------------

export default analytics;
